var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-modal",
    {
      attrs: {
        "modal-class": "scopes-update-wrapper vue-need-bootstrap",
        title: "Update your Etsy store",
        lazy: "",
        centered: "",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
      },
      on: { close: _vm.onSkipHandler },
      model: {
        value: _vm.isVisible,
        callback: function ($$v) {
          _vm.isVisible = $$v
        },
        expression: "isVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "content text-center" },
        [
          _c("p", [
            _vm._v(
              "Due to recent changes in your Etsy account, you need to reconnect your store."
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.sessions, function (session, index) {
            return [
              session.shop
                ? _c("etsy-store-needs-reconnection-modal-item", {
                    key: index,
                    attrs: { shop: session.shop },
                  })
                : _vm._e(),
            ]
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "skip-link",
              attrs: { href: "#" },
              on: { click: _vm.onSkipHandler },
            },
            [_vm._v("Skip for now")]
          ),
          _vm._v(" "),
          _c("p", { staticClass: "legend" }, [
            _vm._v(
              "\n            If you do not reconnect, Customily won't work properly on your Etsy store, and emails for\n            personalization will not be sent.\n        "
            ),
          ]),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }